import styled from 'styled-components'
import {LineSeries, MarkSeries, XAxis, XYPlot, YAxis} from 'react-vis'
import useDimensions from 'use-element-dimensions'
import React from "react";

type ChartLineTypes = {
    className?: string,
    graph: any,
    formatX: (any) => string,
    formatY: (any) => string,
}

class ChartData {
    data

    constructor(data: Array<{ x: any, y: any }>) {
        this.data = data
    }

    getSumValue = () => {
        return this?.data?.map(item => item.y).reduce((a, b) => a + b)
    }
    getAverage = () => {
        const averageValue = this.getSumValue() / this.data.length
        return [{x: this.data[0]?.x, y: averageValue}, {x: this.data[this.data.length - 1]?.x, y: averageValue}]
    }
    getMinMaxValues = () => {
        const values = this.data.map(item => item.y)

        return {
            MAX: Math.max(...values),
            MIN: Math.min(...values)
        }
    }
    getMaxChart = () => {
        const values = this.getMinMaxValues()
        const MAX = this.data.filter(item => item.y === values.MAX)
        return [...MAX]
    }
    getMinChart = () => {
        const values = this.getMinMaxValues()
        const MIN = this.data.filter(item => item.y === values.MIN)
        return [...MIN]
    }
}


function ChartLine(props: ChartLineTypes) {

    const [{width, height}, ref] = useDimensions()

    const axisStyle = {
        ticks: {
            fontSize: '11px',
            color: '#333',
        }
    }

    const data = props.graph
        ? props.graph
        : [
            {x: 1, y: 70},
            {x: 2, y: 15123120},
            {x: 3, y: 221230},
            {x: 4, y: 80},
            {x: 5, y: 102130},
            {x: 6, y: 123},
            {x: 7, y: 100},
            {x: 8, y: 211231231},
            {x: 9, y: 11321111111},
            {x: 10, y: 121231230},
            {x: 11, y: 120}
        ]


    const chart = new ChartData(data)

    return (
        <StyledChartLine ref={ref}>
            <XYPlot  yDomain={[0, chart.getMinMaxValues().MAX * 1.5]} width={width} height={height}>
                <XAxis
                    left={30}
                    tickValues={data.map(item => item.x)}
                    tickFormat={x => `${props.formatX ? props.formatX(x) : x}`}
                    style={axisStyle}
                />
                <YAxis
                    style={axisStyle}

                    tickFormat={y => `${props.formatY ? props.formatY(y) : y}`}/>

                <LineSeries curve='curveCatmullRom'
                            strokeWidth='5px'
                            style={{fill: "white"}}
                            stroke={'#009FF5'}
                            data={data}/>

                <LineSeries curve='curveBasis'
                            stroke={'#FF007C'}
                            strokeStyle={'dashed'}
                            strokeWidth='2px'
                            data={chart.getAverage()}/>

                <MarkSeries data={chart.getMinChart()} fill={'white'} strokeWidth={4} stroke={'#0659C1'}/>
                <MarkSeries data={chart.getMaxChart()} fill={'white'} strokeWidth={4} stroke={'#FFCE00'}/>

            </XYPlot>
        </StyledChartLine>


    )
}


const StyledChartLine = styled.div`
  width: 96%;
  height: 300px;

`


export default ChartLine
